module.exports = __webpack_public_path__ + "static/media/Tapu Fini_gaussian2.ea979b48.png";